import OrganisationHeader from "./OrganisationHeader";
import OrganisationSideBar from "./OrganisationSiderbar";

const OrganisationLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            <div className="min-h-screen">
                <OrganisationSideBar />

                <div className="lg:w-4/5 lg:float-right relative">
                    <OrganisationHeader />
                    <div className="lg:mt-[2em] mt-[8em]">{children}</div>
                </div>
            </div>
        </>
    );
};

export default OrganisationLayout;
